// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"36":"MarketTrendsPage.loadable","161":"PriceMyRentalResultsPage.loadable"}[chunkId] || chunkId) + "." + {"36":"3686b7e2","161":"aa57bba0","355":"bd7393d0","914":"8b0e96cf"}[chunkId] + ".js";
};